module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/notification/send-dialog/send-dialog.component.css
// module id = ./src/app/components/notification/send-dialog/send-dialog.component.css
// module chunks = main